<div class="vl-page">
  <anb-modal-loading [loaderCounter]="loadingService.loaderCounter"></anb-modal-loading>
  <!-- <anb-app-header-v2></anb-app-header-v2> -->
  <app-header
    [title]="'HEADER.TITLE' | translate"
    [primaryMenuTemplate]="primaryMenuTemplate"
    [secondaryMenuTemplate]="secondaryMenuTemplate"
    [logoutUrl]="logoutUrl"
  >
    <ng-template #primaryMenuTemplate> </ng-template>
    <ng-template #secondaryMenuTemplate>
      <a (click)="redirectToHome()" class="vl-link">
        <i class="vl-link__icon vl-link__icon--before vl-vi vl-vi-places-home" aria-hidden="true"></i>
        {{ 'HEADER.DASHBOARD' | translate }}
      </a>
    </ng-template>
  </app-header>
  <app-banner class="vl-u-spacer--small"></app-banner>

  <section>
    <div *ngIf="browserSupported" class="vl-layout" style="margin-top: 2rem">
      <router-outlet></router-outlet>
    </div>

    <div *ngIf="!browserSupported" class="vl-layout vl-layout--wide">
      <div class="vl-alert vl-alert--warning" style="margin: 1.5rem 0rem">
        <div class="vl-alert__icon" aria-hidden="true"></div>
        <div class="vl-alert__content">
          <div class="vl-alert__title">Browser niet ondersteund</div>
          <div class="vl-alert__message">
            <p>Je gebruikt een browser die niet ondersteund is. Gebruik één van de volgende browsers: Chrome, Edge of Firefox.</p>
          </div>
        </div>
      </div>
    </div>
  </section>
</div>
